import { ComponentInstall } from "../../utils";
import BaseTable from "./src";

export default ComponentInstall(BaseTable);
